import { render, staticRenderFns } from "./generate-codebox-code-modal.vue?vue&type=template&id=4365e8c7&"
import script from "./generate-codebox-code-modal.vue?vue&type=script&lang=js&"
export * from "./generate-codebox-code-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "generate-codebox-code-modal.vue"
export default component.exports